// Generated by psc version 0.10.2
"use strict";
var $foreign = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Functor.js");
var Data_Function = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Function.purs");
var Data_Unit = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Unit.purs");
var Control_Semigroupoid = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Semigroupoid.purs");
var Functor = function (map) {
    this.map = map;
};
var map = function (dict) {
    return dict.map;
};
var mapFlipped = function (dictFunctor) {
    return function (fa) {
        return function (f) {
            return map(dictFunctor)(f)(fa);
        };
    };
};
var $$void = function (dictFunctor) {
    return map(dictFunctor)(Data_Function["const"](Data_Unit.unit));
};
var voidLeft = function (dictFunctor) {
    return function (f) {
        return function (x) {
            return map(dictFunctor)(Data_Function["const"](x))(f);
        };
    };
};
var voidRight = function (dictFunctor) {
    return function (x) {
        return map(dictFunctor)(Data_Function["const"](x));
    };
};
var functorFn = new Functor(Control_Semigroupoid.compose(Control_Semigroupoid.semigroupoidFn));
var functorArray = new Functor($foreign.arrayMap);
var flap = function (dictFunctor) {
    return function (ff) {
        return function (x) {
            return map(dictFunctor)(function (f) {
                return f(x);
            })(ff);
        };
    };
};
module.exports = {
    Functor: Functor, 
    flap: flap, 
    map: map, 
    mapFlipped: mapFlipped, 
    "void": $$void, 
    voidLeft: voidLeft, 
    voidRight: voidRight, 
    functorFn: functorFn, 
    functorArray: functorArray
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-prelude/src/Data/Functor.purs
// module id = 0
// module chunks = 0